import { render } from "./OptionsSelect.vue?vue&type=template&id=3ffa8a7a&scoped=true"
import script from "./OptionsSelect.vue?vue&type=script&lang=js"
export * from "./OptionsSelect.vue?vue&type=script&lang=js"

import "./OptionsSelect.vue?vue&type=style&index=0&id=3ffa8a7a&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffa8a7a"]])

export default __exports__